module.exports = __webpack_public_path__ + "img/icon-clipboard-dark-grey.484e2e3d.svg";